import ProfileLayout from "../panel/profile/ProfileLayout";

export default function Profile() {
  return (
    <div className="profile-page-wrapper">
      <ProfileLayout />
    </div>
  );
}
